// extracted by mini-css-extract-plugin
module.exports = {"createIdeaForm":"ideas_createIdeaForm__gA6oY","headingCreateIdea":"ideas_headingCreateIdea__g8QB3","error":"ideas_error__JtZIY","textarea":"ideas_textarea__3Tyf4"};